import { CheckboxList } from "@risalabs_frontend_org/oasis-ui-kit";
import { useEffect, useMemo, useState } from "react";

interface ToggleForMedicalNeccessityProps {
  onToggle: (runMedicalNeccessity: boolean) => void;
  disabled: boolean;
}

const ToggleForMedicalNeccessity = ({
  onToggle,
  disabled,
}: ToggleForMedicalNeccessityProps) => {
  const [runMedicalNeccessity, setRunMedicalNeccessity] = useState(false);

  useEffect(() => {
    onToggle(runMedicalNeccessity);
  }, [runMedicalNeccessity, onToggle]);

  const options = useMemo(
    () => [
      {
        id: "run-medical-neccessity",
        label: "Run Medical Neccessity for the questionnaire",
        checked: runMedicalNeccessity,
        disabled: disabled,
      },
    ],
    [runMedicalNeccessity, disabled],
  );

  return (
    <div className="toggle-for-medical-neccessity mr-auto">
      <CheckboxList
        items={options}
        onSelectionChange={(items) => setRunMedicalNeccessity(items[0].checked)}
        showSelectAll={false}
        className="!w-full"
        width={"100%"}
      />
    </div>
  );
};

export default ToggleForMedicalNeccessity;
